import React from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

import {
  NAV_ITEMS,
  REGISTRATION_STEPS_REQUIRED,
  REGISTRATION_STEPS_REQUIRED_DLP_ONLY,
  REGISTRATION_STEPS_OPTIONAL,
} from "../../../../constants/navigation";
import { NavItemKey } from "../../../../state";
import useAppOrderStatus from "../../../../hooks/manager/useAppOrderStatus";
import useNavLabel from "../../../../hooks/manager/useNavLabel";
import common from "../HomePage.module.scss";

import styles from "./RegistrationStepsSection.module.scss";

const REGISTRATION_STEPS_REQUIRED_TEXTS = "先生、クラス、生徒、教科";
const REGISTRATION_STEPS_REQUIRED_TEXTS_DLP_ONLY = "先生、クラス、生徒";

const RegistrationStepsSection = () => {
  const { hasOnlyDlpOrder } = useAppOrderStatus();
  const { getNavLabel } = useNavLabel();

  const registrationStepsRequired = hasOnlyDlpOrder
    ? REGISTRATION_STEPS_REQUIRED_DLP_ONLY
    : REGISTRATION_STEPS_REQUIRED;

  const registrationStepKeys = hasOnlyDlpOrder
    ? REGISTRATION_STEPS_REQUIRED_DLP_ONLY.navItemKeys
    : [
        ...REGISTRATION_STEPS_REQUIRED.navItemKeys,
        ...REGISTRATION_STEPS_OPTIONAL.navItemKeys,
      ];

  const requiredKeySet = new Set(REGISTRATION_STEPS_REQUIRED.navItemKeys);

  const getStepKind = (key: NavItemKey) =>
    requiredKeySet.has(key)
      ? registrationStepsRequired.kind
      : REGISTRATION_STEPS_OPTIONAL.kind;

  const registrationStepsRequiredTexts = hasOnlyDlpOrder
    ? REGISTRATION_STEPS_REQUIRED_TEXTS_DLP_ONLY
    : REGISTRATION_STEPS_REQUIRED_TEXTS;

  return (
    <section className={common.section}>
      <h2 className={common.h2}>ご登録作業</h2>
      <div className={styles.box}>
        <ul className={styles.list}>
          {registrationStepKeys.map((key, index) => {
            const no = index + 1;
            const kind = getStepKind(key);

            return (
              <li key={key} className={clsx(styles.item, styles[kind])}>
                <span className={styles.no}>{no}</span>
                <Link className={styles.label} to={NAV_ITEMS[key].link}>
                  {getNavLabel(key)}
                </Link>
              </li>
            );
          })}
        </ul>
        <div className={styles.content}>
          <div className={clsx(styles.group, styles.required)}>
            <h3 className={styles.h3}>
              {registrationStepsRequired.navItemKeys.length}つの基本登録
              <span className={styles.badge}>必須</span>
            </h3>
            <p className={styles.desc}>
              メニューバーより、ENAGEEDを行う全ての
              {registrationStepsRequiredTexts}をご登録ください。
              <br />
              登録した{registrationStepsRequiredTexts}
              の情報は、すべてのサービスに自動で反映されます。
            </p>
          </div>
          {!hasOnlyDlpOrder && (
            <div className={clsx(styles.group, styles.optional)}>
              <h3 className={styles.h3}>
                {REGISTRATION_STEPS_OPTIONAL.navItemKeys.length}つの追加登録
                <span className={styles.badge}>任意</span>
              </h3>
              <p className={styles.desc}>
                {getNavLabel("studentPhotos")}
                ：LOUNGEでの一覧表示が見やすくなります。
                <br />
                {getNavLabel("subClasses")}
                ：クラスを跨いだグループを登録することができます。例 /
                委員会、部活動
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RegistrationStepsSection;
